import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";
import { getCardTransactions } from "utils/AxiosUtil";
import { isNoAddress } from "utils/card";

interface CardTransactionsResult {
  transactions: any[];
  more: boolean;
}

export function useCardTransactions(cardAlias: string | undefined) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  return useQuery<CardTransactionsResult>({
    // History is per-token on the backend, so this is correctness, not just freshness.
    queryKey: ["cardTransactions", cardAlias, token],
    queryFn: () => getCardTransactions(cardAlias!, networkType, token),
    enabled: !!user && !!cardAlias && !isNoAddress(cardAlias),
  });
}
